import React from 'react';
import cn from 'classnames';
import { TextButton } from "../TextButton";
import styles from "./FilterPickerGroup.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function FilterPickerGroup(props) {
  const {
    className,
    style,
    children,
    flexWrap,
    onClearClick,
    disableClear
  } = props;
  const testId = props['data-testid'];
  return /*#__PURE__*/_jsxs("div", {
    style: style,
    className: cn(styles.root, {
      [styles.flexWrap]: flexWrap
    }, className),
    "data-testid": testId,
    children: [children, onClearClick ? /*#__PURE__*/_jsx(TextButton, {
      onClick: onClearClick,
      skin: "secondary",
      disabled: disableClear,
      "data-testid": "".concat(testId, "-clear"),
      children: "Clear"
    }) : null]
  });
}